function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessmentMainGraphicDnaa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 2258 1579",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M165.665 229.06h-9.961a6.993 6.993 0 0 1-5.332-2.465l-.3-.352H6.458c-4.871 0-8.835-3.958-8.846-8.828L5.698 27.299c.101-.135.663-.72 3.29-1.624 2.002-.689 4.817-1.434 8.364-2.214 6.191-1.361 14.505-2.815 24.712-4.322 18.102-2.673 36.267-4.627 38.834-4.627h.038l.037-.003c.143-.011 14.539-1.071 31.301-1.071 15.697 0 28.262.897 37.346 2.666l.586.114.378-.461c.827-1.006 2.611-1.886 5.304-2.616 2.613-.708 6.064-1.275 10.551-1.734 8.506-.87 19.851-1.237 31.863-1.626 12.496-.405 26.659-.864 40.348-1.966 35.691-2.872 69.413-4.224 70.398-4.263 4.869.011 8.827 3.976 8.827 8.848v204.995c0 4.879-3.968 8.848-8.846 8.848H171.297l-.3.352a6.993 6.993 0 0 1-5.332 2.465Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "rotate(-8 1683.785 -187.633) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.665 228.06c1.761 0 3.427-.77 4.571-2.114l.599-.703h138.194c4.326 0 7.846-3.521 7.846-7.848V12.4c0-4.315-3.5-7.827-7.809-7.848-1.374.055-34.883 1.407-70.335 4.26-13.714 1.104-27.89 1.563-40.396 1.968-11.994.389-23.323.756-31.794 1.622-4.433.453-7.832 1.01-10.391 1.704-3.1.84-4.317 1.707-4.793 2.286l-.757.922-1.171-.228c-9.021-1.757-21.522-2.648-37.155-2.648-16.721 0-31.084 1.057-31.227 1.068l-.074.006h-.075c-2.433 0-20.013 1.886-37.666 4.466-9.985 1.459-18.224 2.874-24.488 4.205-3.571.759-6.459 1.485-8.584 2.158-2.19.694-3.119 1.194-3.481 1.433l-8.067 189.661c.021 4.309 3.533 7.808 7.846 7.808h144.076l.599.703a5.997 5.997 0 0 0 4.571 2.114h9.961m0 2h-9.961a7.987 7.987 0 0 1-6.094-2.817H6.458c-5.437 0-9.847-4.409-9.847-9.848L4.701 27.21c0-5.439 70.759-13.698 76.197-13.698 0 0 43.835-3.274 68.913 1.611 6.106-7.434 48.634-5.074 88.759-8.305 36.48-2.935 70.459-4.266 70.459-4.266 5.438 0 9.846 4.41 9.846 9.848v204.995c0 5.439-4.408 9.848-9.846 9.848h-137.27a7.985 7.985 0 0 1-6.094 2.817Z",
    style: {
      fill: "#747683",
      fillRule: "nonzero"
    },
    transform: "rotate(-8 1683.785 -187.633) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.906 224.083h-9.397a7.026 7.026 0 0 1-6.578-4.598l-.24-.657H9.634c-4.761 0-8.634-3.874-8.634-8.635V9.634C1 4.876 4.868 1.005 9.624 1c.671.013 30.488.577 62.882 1.71 19.143.67 35.426 1.405 48.396 2.183 16.179.972 27.199 2.013 32.752 3.094l.168.033.168-.025c10.182-1.496 39.632-3.18 85.167-4.87A7038.51 7038.51 0 0 1 305.67 1c4.755.007 8.621 3.877 8.621 8.634v200.559c0 4.761-3.873 8.635-8.634 8.635H168.724l-.24.657a7.026 7.026 0 0 1-6.578 4.598Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "rotate(-8 2226.016 -73.751) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.906 223.083a6.022 6.022 0 0 0 5.639-3.941l.479-1.314h137.633c4.209 0 7.634-3.425 7.634-7.635V9.634c0-4.202-3.411-7.621-7.61-7.634-1.115.03-32.515.864-66.489 2.125-45.498 1.688-74.91 3.368-85.056 4.859l-.338.05-.335-.065c-9.931-1.934-37.936-3.753-80.99-5.259A4373.616 4373.616 0 0 0 9.615 2C5.415 2.01 2 5.431 2 9.634v200.559c0 4.21 3.424 7.635 7.634 7.635h136.757l.48 1.313a6.02 6.02 0 0 0 5.638 3.942h9.397m0 2h-9.397a8.004 8.004 0 0 1-7.517-5.255H9.634c-5.321 0-9.634-4.314-9.634-9.635V9.634A9.634 9.634 0 0 1 9.634 0s119.675 2.227 144.211 7.006C178.833 3.334 305.657 0 305.657 0a9.634 9.634 0 0 1 9.634 9.634v200.559c0 5.321-4.313 9.635-9.634 9.635H169.423a8.003 8.003 0 0 1-7.517 5.255Z",
    style: {
      fill: "#747683",
      fillRule: "nonzero"
    },
    transform: "rotate(-8 2226.016 -73.751) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.144 7v31.542c0 3.863-3.137 7-7 7H7c-3.863 0-7-3.137-7-7V7c0-3.863 3.137-7 7-7h6.144c3.863 0 7 3.137 7 7Z",
    style: {
      fill: "#fec633"
    },
    transform: "rotate(-8 3085.333 215.75) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.144 7v31.542c0 3.311-2.689 6-6 6H7c-3.311 0-6-2.689-6-6V7c0-3.311 2.689-6 6-6h6.144c3.311 0 6 2.689 6 6Z",
    style: {
      fill: "none",
      stroke: "#707070",
      strokeWidth: 2
    },
    transform: "rotate(-8 3085.333 215.75) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.144 7v31.542c0 3.863-3.137 7-7 7H7c-3.863 0-7-3.137-7-7V7c0-3.863 3.137-7 7-7h6.144c3.863 0 7 3.137 7 7Z",
    style: {
      fill: "#4359db"
    },
    transform: "rotate(-8 5659.844 35.714) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.144 7v31.542c0 3.311-2.689 6-6 6H7c-3.311 0-6-2.689-6-6V7c0-3.311 2.689-6 6-6h6.144c3.311 0 6 2.689 6 6Z",
    style: {
      fill: "none",
      stroke: "#707070",
      strokeWidth: 2
    },
    transform: "rotate(-8 5659.844 35.714) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.144 7v31.542c0 3.863-3.137 7-7 7H7c-3.863 0-7-3.137-7-7V7c0-3.863 3.137-7 7-7h6.144c3.863 0 7 3.137 7 7Z",
    style: {
      fill: "#4359db"
    },
    transform: "rotate(172 935.906 420.998) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.144 7v31.542c0 3.311-2.689 6-6 6H7c-3.311 0-6-2.689-6-6V7c0-3.311 2.689-6 6-6h6.144c3.311 0 6 2.689 6 6Z",
    style: {
      fill: "none",
      stroke: "#707070",
      strokeWidth: 2
    },
    transform: "rotate(172 935.906 420.998) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.144 7v31.542c0 3.863-3.137 7-7 7H7c-3.863 0-7-3.137-7-7V7c0-3.863 3.137-7 7-7h6.144c3.863 0 7 3.137 7 7Z",
    style: {
      fill: "#fec633"
    },
    transform: "rotate(172 925.868 277.462) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.144 7v31.542c0 3.311-2.689 6-6 6H7c-3.311 0-6-2.689-6-6V7c0-3.311 2.689-6 6-6h6.144c3.311 0 6 2.689 6 6Z",
    style: {
      fill: "none",
      stroke: "#707070",
      strokeWidth: 2
    },
    transform: "rotate(172 925.868 277.462) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.013 44.542H6.131A5.137 5.137 0 0 1 1 39.411V6.131A5.137 5.137 0 0 1 6.131 1h7.882a5.137 5.137 0 0 1 5.131 5.131v33.28a5.137 5.137 0 0 1-5.131 5.131Z",
    style: {
      fill: "#f27931",
      fillRule: "nonzero"
    },
    transform: "rotate(172 949.345 613.187) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.131 2A4.135 4.135 0 0 0 2 6.131v33.28a4.135 4.135 0 0 0 4.131 4.131h7.882a4.135 4.135 0 0 0 4.131-4.131V6.131A4.135 4.135 0 0 0 14.013 2H6.131m0-2h7.882a6.131 6.131 0 0 1 6.131 6.131v33.28a6.131 6.131 0 0 1-6.131 6.131H6.131A6.131 6.131 0 0 1 0 39.411V6.131A6.131 6.131 0 0 1 6.131 0Z",
    style: {
      fill: "#707070",
      fillRule: "nonzero"
    },
    transform: "rotate(172 949.345 613.187) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15.765v190.05H0z",
    style: {
      fill: "#fff"
    },
    transform: "rotate(-8 2733.285 -319.025) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15.765v190.05H0z",
    style: {
      fill: "#fff"
    },
    transform: "rotate(-8 1920.73 -11939.12) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.865 8v69.207c0 4.415-3.585 8-8 8H8c-4.415 0-8-3.585-8-8V8c0-4.415 3.585-8 8-8h59.865c4.415 0 8 3.585 8 8Z",
    style: {
      fill: "#0279cf"
    },
    transform: "rotate(6 -2123.936 11927.77) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.865 8v69.207c0 3.863-3.137 7-7 7H8c-3.863 0-7-3.137-7-7V8c0-3.863 3.137-7 7-7h59.865c3.863 0 7 3.137 7 7Z",
    style: {
      fill: "none",
      stroke: "#707070",
      strokeWidth: 2
    },
    transform: "rotate(6 -2123.936 11927.77) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.14 8v2.645c0 4.415-3.585 8-8 8H8c-4.415 0-8-3.585-8-8V8c0-4.415 3.585-8 8-8h86.14c4.415 0 8 3.585 8 8Z",
    style: {
      fill: "#fff"
    },
    transform: "rotate(6 -5661.034 11055.46) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.865 8v69.207c0 4.415-3.585 8-8 8H8c-4.415 0-8-3.585-8-8V8c0-4.415 3.585-8 8-8h59.865c4.415 0 8 3.585 8 8Z",
    style: {
      fill: "#25a9ef"
    },
    transform: "scale(5.55556) rotate(-39 125.913 -9.312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.865 8v69.207c0 3.863-3.137 7-7 7H8c-3.863 0-7-3.137-7-7V8c0-3.863 3.137-7 7-7h59.865c3.863 0 7 3.137 7 7Z",
    style: {
      fill: "none",
      stroke: "#707070",
      strokeWidth: 2
    },
    transform: "scale(5.55556) rotate(-39 125.913 -9.312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.14 8v2.645c0 4.415-3.585 8-8 8H8c-4.415 0-8-3.585-8-8V8c0-4.415 3.585-8 8-8h86.14c4.415 0 8 3.585 8 8Z",
    style: {
      fill: "#fff"
    },
    transform: "scale(5.55556) rotate(-39 227.557 -24.769)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.102 5v79.982c0 2.76-2.24 5-5 5H5c-2.76 0-5-2.24-5-5V5c0-2.76 2.24-5 5-5h17.102c2.76 0 5 2.24 5 5Z",
    style: {
      fill: "#f27931"
    },
    transform: "rotate(-8 6035.753 -7337.746) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.102 5v79.982c0 2.208-1.792 4-4 4H5c-2.208 0-4-1.792-4-4V5c0-2.208 1.792-4 4-4h17.102c2.208 0 4 1.792 4 4Z",
    style: {
      fill: "none",
      stroke: "#747683",
      strokeWidth: 2
    },
    transform: "rotate(-8 6035.753 -7337.746) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.102 5v37.95c0 2.76-2.24 5-5 5H5c-2.76 0-5-2.24-5-5V5c0-2.76 2.24-5 5-5h17.102c2.76 0 5 2.24 5 5Z",
    style: {
      fill: "#fec633"
    },
    transform: "rotate(-8 7606.991 -8862.363) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.102 5v37.95c0 2.208-1.792 4-4 4H5c-2.208 0-4-1.792-4-4V5c0-2.208 1.792-4 4-4h17.102c2.208 0 4 1.792 4 4Z",
    style: {
      fill: "none",
      stroke: "#747683",
      strokeWidth: 2
    },
    transform: "rotate(-8 7606.991 -8862.363) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.187 5v50.459c0 2.76-2.24 5-5 5H5c-2.76 0-5-2.24-5-5V5c0-2.76 2.24-5 5-5h19.187c2.76 0 5 2.24 5 5Z",
    style: {
      fill: "#25a9ef"
    },
    transform: "rotate(-8 7011.633 -10235.519) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.187 5v50.459c0 2.208-1.792 4-4 4H5c-2.208 0-4-1.792-4-4V5c0-2.208 1.792-4 4-4h19.187c2.208 0 4 1.792 4 4Z",
    style: {
      fill: "none",
      stroke: "#747683",
      strokeWidth: 2
    },
    transform: "rotate(-8 7011.633 -10235.519) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h115.607v7.882H0z",
    style: {
      fill: "#fff"
    },
    transform: "rotate(-8 9445.002 -7186.179) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.966 17.83H3.503c-.808 0-1.385-.654-1.657-1.043C1.308 16.016 1 14.931 1 13.809V5.021c0-1.122.308-2.207.846-2.978C2.118 1.653 2.695 1 3.503 1h95.463c.809 0 1.386.653 1.657 1.043.538.771.847 1.856.847 2.978v8.788c0 1.122-.309 2.207-.847 2.978-.271.389-.848 1.043-1.657 1.043Z",
    style: {
      fill: "#ffefe4",
      fillRule: "nonzero"
    },
    transform: "rotate(-8 6506.387 -1596.72) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.503 2C2.905 2 2 3.205 2 5.021v8.788c0 1.816.905 3.021 1.503 3.021h95.463c.599 0 1.504-1.205 1.504-3.021V5.021c0-1.816-.905-3.021-1.504-3.021H3.503m0-2h95.463c1.935 0 3.504 2.248 3.504 5.021v8.788c0 2.773-1.569 5.021-3.504 5.021H3.503C1.568 18.83 0 16.582 0 13.809V5.021C0 2.248 1.568 0 3.503 0Z",
    style: {
      fill: "#747683",
      fillRule: "nonzero"
    },
    transform: "rotate(-8 6506.387 -1596.72) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h115.607v6.131H0z",
    style: {
      fill: "#fff"
    },
    transform: "rotate(-8 7089.802 -1252.942) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.966 17.83H3.503c-.808 0-1.385-.654-1.657-1.043C1.308 16.016 1 14.931 1 13.809V5.021c0-1.122.308-2.207.846-2.978C2.118 1.653 2.695 1 3.503 1h95.463c.809 0 1.386.653 1.657 1.043.538.771.847 1.856.847 2.978v8.788c0 1.122-.309 2.207-.847 2.978-.271.389-.848 1.043-1.657 1.043Z",
    style: {
      fill: "#ffefe4",
      fillRule: "nonzero"
    },
    transform: "rotate(-8 7410.929 -1659.969) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.503 2C2.905 2 2 3.205 2 5.021v8.788c0 1.816.905 3.021 1.503 3.021h95.463c.599 0 1.504-1.205 1.504-3.021V5.021c0-1.816-.905-3.021-1.504-3.021H3.503m0-2h95.463c1.935 0 3.504 2.248 3.504 5.021v8.788c0 2.773-1.569 5.021-3.504 5.021H3.503C1.568 18.83 0 16.582 0 13.809V5.021C0 2.248 1.568 0 3.503 0Z",
    style: {
      fill: "#747683",
      fillRule: "nonzero"
    },
    transform: "rotate(-8 7410.929 -1659.969) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h115.607v6.131H0z",
    style: {
      fill: "#fff"
    },
    transform: "rotate(-8 7994.344 -1316.191) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.966 17.83H3.503c-.808 0-1.385-.654-1.657-1.043C1.308 16.016 1 14.931 1 13.809V5.021c0-1.122.308-2.207.846-2.978C2.118 1.653 2.695 1 3.503 1h95.463c.809 0 1.386.653 1.657 1.043.538.771.847 1.856.847 2.978v8.788c0 1.122-.309 2.207-.847 2.978-.271.389-.848 1.043-1.657 1.043Z",
    style: {
      fill: "#ffefe4",
      fillRule: "nonzero"
    },
    transform: "rotate(-8 8315.511 -1723.215) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.503 2C2.905 2 2 3.205 2 5.021v8.788c0 1.816.905 3.021 1.503 3.021h95.463c.599 0 1.504-1.205 1.504-3.021V5.021c0-1.816-.905-3.021-1.504-3.021H3.503m0-2h95.463c1.935 0 3.504 2.248 3.504 5.021v8.788c0 2.773-1.569 5.021-3.504 5.021H3.503C1.568 18.83 0 16.582 0 13.809V5.021C0 2.248 1.568 0 3.503 0Z",
    style: {
      fill: "#747683",
      fillRule: "nonzero"
    },
    transform: "rotate(-8 8315.511 -1723.215) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h115.607v6.131H0z",
    style: {
      fill: "#fff"
    },
    transform: "rotate(-8 8898.926 -1379.438) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v176.1",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#747683",
      strokeWidth: 2,
      strokeLinecap: "round"
    },
    transform: "rotate(-8 2626.225 -6349.556) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.142 19.644H10.072C4.794 19.644.5 15.35.5 10.072S4.794.5 10.072.5h108.07c5.278 0 9.572 4.294 9.572 9.572s-4.294 9.572-9.572 9.572Z",
    style: {
      fill: "#ffefe4",
      fillRule: "nonzero"
    },
    transform: "rotate(43 -414.623 2710.193) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.072 1C5.07 1 1 5.07 1 10.072c0 5.002 4.07 9.072 9.072 9.072h108.07c5.002 0 9.072-4.07 9.072-9.072 0-5.002-4.07-9.072-9.072-9.072H10.072m0-1h108.07c5.563 0 10.072 4.509 10.072 10.072 0 5.562-4.509 10.072-10.072 10.072H10.072C4.509 20.144 0 15.634 0 10.072 0 4.509 4.509 0 10.072 0Z",
    style: {
      fill: "#707070",
      fillRule: "nonzero"
    },
    transform: "rotate(43 -414.623 2710.193) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h117.402v20.144H0z",
    style: {
      fill: "#ffefe4"
    },
    transform: "rotate(43 -414.623 2710.193) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5.5h116.402v19.144H.5z",
    style: {
      fill: "none",
      stroke: "#707070",
      strokeWidth: 1
    },
    transform: "rotate(43 -414.623 2710.193) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.263 16.394H.88L10.072.976l9.191 15.418Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "rotate(-47 1978.911 -1316.322) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.072 1.953 1.76 15.894h16.623L10.072 1.953m0-1.953 10.072 16.894H0L10.072 0Z",
    style: {
      fill: "#707070",
      fillRule: "nonzero"
    },
    transform: "rotate(-47 1978.911 -1316.322) scale(5.55556)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentMainGraphicDnaa);
export default __webpack_public_path__ + "static/media/assessment-main-graphic-dnaa.64dce7f5b599936a2b9484e144c22cff.svg";
export { ForwardRef as ReactComponent };